import { supabase } from '@/integrations/supabase/client';

// Direct fetch to Edge Function - bypasses Supabase SDK issues in Telegram WebView
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://wwuylzllmsegwdizkxdx.supabase.co';

export type TgSessionResult =
  | { ok: true }
  | { ok: false; error: string };

export async function exchangeTelegramSession(initData: string): Promise<TgSessionResult> {
  try {
    // Use direct fetch instead of supabase.functions.invoke
    // This bypasses SDK headers that may cause issues in Telegram WebView
    // eslint-disable-next-line internal/no-direct-edge-fetch -- Special case: Telegram auth exchange in WebView
    const response = await fetch(`${SUPABASE_URL}/functions/v1/telegram-auth-exchange`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ initData }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('[TG Session] HTTP error:', response.status);
      return { ok: false, error: data?.error || 'rpc_failed' };
    }

    const resultData = data as { ok: boolean; tokens?: any; error?: string };

    if (!resultData.ok) {
      return { ok: false, error: resultData.error || 'rpc_failed' };
    }

    const tokens = resultData.tokens as {
      access_token: string;
      refresh_token: string;
      expires_in?: number;
    } | undefined;

    if (!tokens?.access_token || !tokens?.refresh_token) {
      return { ok: false, error: 'bad_tokens' };
    }

    // Persist session in the browser (supabase-js)
    const { error: sessionError } = await supabase.auth.setSession({
      access_token: tokens.access_token,
      refresh_token: tokens.refresh_token,
    });

    if (sessionError) {
      return { ok: false, error: sessionError.message };
    }

    return { ok: true };
  } catch (error) {
    console.error('[TG Session] Exchange failed:', error);
    return { ok: false, error: 'network_error' };
  }
}